/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import { IRequestTaller, IFormato, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { Taller, Sala } from 'utils/models/types';
import { crearOpcionesTipos } from 'utils/utilities';
import { anchoMaxLogueado, opcionesDias } from 'utils/constants';
import { useError } from 'services/ErrorContext';
import Spinner from 'components/public/Spinner/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSalas } from 'utils/redux/features/salasSlice';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { AddCommentOutlined } from '@mui/icons-material';
import NoResponse from 'pages/auxiliares/NoResponse';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useParams } from 'react-router-dom';
import { fetchTallerPorId } from 'utils/redux/features/tallerIdSlice';
import { edicionTaller } from 'services/servicioPut';

interface IFormTaller {
  titulo: string;
  textoBoton: string;
}

const EdicionTaller = ({ titulo, textoBoton }: IFormTaller) => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { id } = useParams();
  const { salas, loadingSalas, errorSalas } = useSelector((state: RootState) => state.salas);
  const { taller, loadingTaller, errorTaller } = useSelector((state: RootState) => state.taller);
  const { error, setError, clearError, loading, setLoading } = useError();
  const dispatch = useDispatch<AppDispatch>();
  const opcionesSalas: ISelectOptions[] = crearOpcionesTipos(salas, 'Sala');
  const error401 = errorSalas?.includes('permisos');
  const salaId = salas.find((sala: Sala) => sala.Nombre === taller.NombreSala)?.Id;

  useEffect(() => {
    dispatch(fetchSalas());
    dispatch(fetchTallerPorId(Number(id)));
  }, [dispatch]);

  const datosEdicionTaller: IFormato<Taller>[] = [
    { name: 'Nombre', label: 'Nombre de taller', subtituloSeccion: 'Datos básicos', defaultValue: taller.Nombre },
    { name: 'Docente', label: 'Docente', defaultValue: taller.Docente },
    { name: 'Afiche', label: 'Afiche', inputType: 'file', required: false },
    {
      name: 'Programa',
      label: 'Programa',
      inputType: 'textarea',
      subtituloSeccion: 'Detalles',
      defaultValue: taller.Programa,
    },
    { name: 'Sala', label: 'Sala', inputType: 'select', halfWidth: 'left', defaultValue: salaId },
    {
      name: 'ValorCuota',
      label: 'Valor de la cuota',
      inputType: 'number',
      halfWidth: 'right',
      adornment: '$',
      defaultValue: taller.ValorCuota,
    },
    {
      name: 'VisibleEnGrilla',
      label: 'Visible en grilla',
      inputType: 'checkbox',
      required: false,
      defaultValue: taller.VisibleEnGrilla,
    },
  ];

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const afiche: IFile = data?.Afiche !== undefined && data?.Afiche[0];

    const request: IRequestTaller = {
      Id: taller.Id,
      Nombre: data.Nombre,
      SalaId: salaId || 1,
      Docente: data.Docente,
      Programa: data.Programa,
      ValorCuota: data.ValorCuota,
      Afiche: afiche || '',
      VisibleEnGrilla: data.VisibleEnGrilla,
    };

    const formData = new FormData();
    formData.append('Id', request.Id!.toString());
    formData.append('Nombre', request.Nombre);
    formData.append('SalaId', request.SalaId.toString());
    formData.append('Docente', request.Docente);
    formData.append('Programa', request.Programa);
    formData.append('ValorCuota', request.ValorCuota.toString());
    formData.append('Afiche', afiche || '');
    formData.append('VisibleEnGrilla', request.VisibleEnGrilla.toString());

    try {
      await edicionTaller(request, setError, setLoading, true, formData);
      setMensajeExito('¡Taller modificado con éxito!');
    } catch (error) {
      console.error('Error de edición:', error);
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <DashboardContainer>
      {loadingSalas || loadingTaller ? (
        <Spinner />
      ) : errorSalas || errorTaller ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Box maxWidth={anchoMaxLogueado} mx="auto">
          <Formulario
            campos={datosEdicionTaller}
            datos={opcionesDias.concat(opcionesSalas)}
            titulo={titulo}
            textoBoton={textoBoton}
            onSubmit={handleSubmit}
            onVolver={handleVolver}
            mensajeExito={mensajeExito}
            mensajeError={error}
            loading={loading}
            iconoBoton={AddCommentOutlined}
          />
        </Box>
      )}
    </DashboardContainer>
  );
};

export default EdicionTaller;
